import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { QrCodeModule } from 'ng-qrcode';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { BonoFormComponent } from './public/bono-form/bono-form.component';
import { BonoEstaticoComponent } from './public/bono-estatico/bono-estatico.component';
import { BonoDinamicoComponent } from './public/bono-dinamico/bono-dinamico.component';
import { QrDinamicoGeneratorComponent } from './generator/qr-dinamico-generator/qr-dinamico-generator.component';
import { BonusQrListComponent } from './management/bonus-qr-list/bonus-qr-list.component';
import { BonusQrDetailComponent } from './management/bonus-qr-detail/bonus-qr-detail.component';
import { BonusQrPerformanceComponent } from './management/bonus-qr-performance/bonus-qr-performance.component';
import { BonusQrSummaryComponent } from './management/bonus-qr-summary/bonus-qr-summary.component';
import { BonusQrReferralsComponent } from './management/bonus-qr-referrals/bonus-qr-referrals.component';
import { BonusQrReferralsDetailComponent } from './management/bonus-qr-referrals-detail/bonus-qr-referrals-detail.component';

@NgModule({
  declarations: [
    BonoFormComponent,
    BonoEstaticoComponent,
    BonoDinamicoComponent,
    QrDinamicoGeneratorComponent,
    BonusQrListComponent,
    BonusQrDetailComponent,
    BonusQrPerformanceComponent,
    BonusQrSummaryComponent,
    BonusQrReferralsComponent,
    BonusQrReferralsDetailComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxPaginationModule,
    QrCodeModule,
    TypeaheadModule.forRoot(),
  ],
  exports: [
    BonoEstaticoComponent,
    BonoDinamicoComponent,
    QrDinamicoGeneratorComponent,
    BonusQrListComponent,
    BonusQrDetailComponent,
    BonusQrPerformanceComponent,
    BonusQrSummaryComponent,
    BonusQrReferralsComponent,
    BonusQrReferralsDetailComponent,
  ],
})
export class BonusQrModule {}
